function scrollTop() {
  const wrapper = document.getElementsByClassName('main-wrapper')[0];
  if (wrapper) {
    wrapper.scrollIntoView();
  }
}

export default scrollTop;
